module.exports = __webpack_public_path__ + "static/abilia-hero-18c3391c12943ec485b18fd02a0f6af3.jpg";